/* eslint-disable */
import { Translate } from 'types';

export const langEn:Translate = {
  'моспром': 'Mosprom',
  'услуги':`Services`,
  'экспортерам':`For exporters`,
  'мероприятия':`Events`,
  'аналитика':`Analytics`,
  'о нас':`About us`,
  'медиа':`Media`,
  'контакты':`Contacts`,
  'центр поддержки экспортеров':`Export Support Center`,
  'главный инструмент московского экспорта':`Key instrument of Moscow exports`,
  'личный кабинет':`Account`,
  'в личный кабинет':`Account`,
  'телефон':`Phone`,
  'адрес':`Address`,
  'общие показатели экспорта москвы:':`MOSCOW EXPORT INDICATORS:`,
  '* за 2020 год':`* 2020`,
  '* за {0} год':`* {0}`,
  '125009, россия, г. москва':`Moscow, Russia, 125009`,
  'россия':`Russia`,
  'г. москва':`Moscow`,
  'большой кисловский переулок, дом 6':`6, Bol'shoy kislovskiy pereulok`,
  'пресненская набережная, д. 8 стр. 1':`8 building 1, Presnenskaya naberezhnaya`,
  'общие показатели центра «моспром»:':`MOSPROM PERFORMANCE INDICATORS:`,
  'консультации в области вэд:':`Consultations in the field of foreign economic activity:`,
  'страны':`countries`,
  'стран':`countries`,
  'индивидуальная поддержка':`Personalized support`,
  'импортирует продукцию столицы':`importing Moscow products`,
  'млн':`mln`,
  'млрд':`bln`,
  'байерская программа':`Buyer program`,
  'аналитические исследования':`Analytical research`,
  'подробнее':`More details`,
  
  'библиотека экспортера':`EXPORTERS’ LIBRARY`,
  'центр «моспром» был создан департаментом...':`The Mosprom Center was established by the Moscow Department of Investment and Industrial Policy to support exports of industrial and agro-industrial products of Moscow. The center plays a leading role in the development of Moscow’s foreign economic activity. Specialists render support to Moscow manufacturers and foreign buyers in building stable cooperation and trade relationships.`,
  'рост московских компаний за рубежом является главным приоритетом...':`The growth of Moscow companies’ operations abroad is the main priority. The center offers various levels of export support, depending on needs, maturity, scale and capacities of Moscow manufacturers. As a result of this approach, support is given wherever it is essential.`,
  'исследования международных рынков являются ключом к экспорту...':`Research of global markets is a key to exports. It helps you understand where to invest your time and resources and how to choose the best approach to a foreign market. The Mosprom Center releases comprehensive global market guides covering macro-indicators, dynamics, features of business culture, rules of business, and opportunities for Moscow businesses. Moscow companies can also access niche or individual marketing research.`,
  'специалисты центра оказывают помощь по базовым и практическим...':`The center works with Moscow export-oriented manufacturers of industrial and agro-industrial products. It offers various levels of export support, depending on needs, maturity, scale and capacities of Moscow manufacturers. As a result of this approach, support is given wherever it is essential. <br/> Center specialists give assistance in basic and practical aspects of foreign economic activity, including certification issues, ways to overcome trade barriers, customs regulations, resolution of current problems, and choice of support required by Moscow exporters.`,
  'московским производителям, которые находятся на более ранней стадии своего развития за рубежом...': 'For those Moscow manufacturers, who are just beginning their operations abroad, the center offers personalized support to help their business establish itself on the international level.',
  'действующим экспортерам москвы, которые хотят увеличить свое присутствие на международной арене...':`The center offers intensive personalized support to existent Moscow exporters wishing to expand their presence on the international arena.`,
  'программа центра направлена на подбор контрагентов и...':`The center’s program aims to choose counterparties and to hold quality negotiations with potential foreign buyers.`,
  'индивидуальная поддержка по участию в международных выставках и...':`Personalized support to participation in international exhibitions and joint participation of best Moscow manufacturers in international exhibitions`,
  'участие столичных компаний в программе на 100% финансируется за счет...':`Participation of Moscow companies in the program is fully funded by the Moscow government (except travel and accommodation expenses)`,
  'узнать больше':`More details`,
  'тест экспортной готовности':`EXPORT PREPAREDNESS TEST`,
  'протестируй первую в россии модель оценки экспортного потенциала «adept 7»':`Try Russia’s first export potential assessment model ADEPT 7`,
  'оставить заявку':`File an application`,
  'новости':`News`,
  'все новости':`All news`,
  'международные бизнес-миссии и выставки, обучающая программа...':`International business missions and exhibitions, coaching program, strategic sessions. All events useful for exporters in one place`,
  'все мероприятия':`All events`,
  'полный перечень существующих мер поддержки...':`Quick access to full list of measures in support of exporters`,
  'ано центр поддержки и развития промышленного экспорта...':`ANO "Center for Support of Export, Industry and Investment Activities "Mosprom"`,
  'новости, статьи, интервью и...':`News, articles, interviews, any kind of useful information about exports`,
  'e-mail':`Email`,
  'email':`Email`,
  'контактная почта':`Email`,
  'экспорт (ннэ) москвы в {0} году':`Moscow’s non-resource non-energy exports in {0}`,
  'рост столичного экспорта по сравнению с {0} годом':`growth of Moscow exports compared to {0}`,
  'успешно проведённых байерских мероприятий':`Successful buyer events`,
  'Консультаций в области ВЭД':`Consultations on foreign economic activity`,
  'Верификаций зарубежных контрагентов':`Verification of foreign counterparties`,
  'область продукции для экспорта':`Export area`,
  'направления мер поддержки':`Areas of support`,
  'сроки подачи':`Submission deadlines`,
  'размер предприятия':`Enterprise size`,
  'формат предоставления меры поддержки':`Support format`,
  'меры поддержки':`Support measures`,
  'к сожалению, ничего не найдено':'No data found',
  'применить':`Apply`,
  'фильтр':`Filter`,
  'сбросить все':`Reset all`,
  'сбросить всё':`Reset all`,
  'календарь мероприятий':`Calendar of events`,
  'сбросить':`Reset`,
  'введите значение':`Enter value`,
  'формат мероприятия':`Event format`,
  'формат':`Format`,
  'выбрать дату':`Choose date`,
  'дата мероприятия':`Date`,
  'архивные мероприятия':`Archived events`,
  'отрасль':`Department`,
  'войти':`LOG IN`,
  'вход в личный кабинет':`Log in to account`,
  'логин':`Login`,
  'пароль':`Password`,
  'подтверждение пароля':`Password confirmation`,
  'подтвердите пароль':`Check confirmation`,
  'сохранить пароль':`Save password`,
  'забыли пароль?':`Forgot your password?`,
  'регистрация':`Registration`,
  'зарегистрироваться':`Sign up`,
  'создайте аккаунт':'Create an account',
  'оформить заявку':`File an application`,
  'название компании':`Company name`,
  'инн':`TIN`,
  'инн компании':`Company TIN`,
  'огрн':`PSRN`,
  'фио':`Name`,
  'должность':`Position`,
  'контактный телефон':`Phone`,
  'номер телефона':`Phone`,
  'фамилия имя отчество': 'Full Name (Surname name and middle name)',
  'введите текст': 'Input text',
  'вы успешно зарегестрировались. Перейти в личный кабинет?': 'Registration successfully. Go to Profile?',
  'вернуться на сайт': 'Return to site',
  'перейти в ЛК': 'Go to Profile',
  'аналитика по странам': 'Country analytics',
  'найти страну': 'Find a country',
  'страна': 'Сountry',
  'выбрать регион': 'Find a region',
  'регион': 'Region',
  'ответственный орган': 'Designated agency',
  'аналитический отчет': 'Analytical report',
  'аналитические исследования по индустриям': 'Analytical research by industry',
  'аналитика по индустриям': 'Industry analytics',
  'информация о компании':`Information about the company`,
  'агент':`Agent`,
  'или':`or`,
  'личные данные':`Personal data`,
  'фамилия':`Last name`,
  'имя':`Name`,
  'отчество':`Middle name`,
  'заявка на прохождение теста':`File for taking a test`,
  'даю своё согласие на обработку персональных данных':`I consent to the processing of personal data`,
  'даю свое согласие на обработку персональных данных':`I consent to the processing of personal data`,
  'даю своё согласие на обработку':`I consent to the processing of`,
  'даю свое согласие на обработку':`I consent to the processing of`,
  'персональных данных':`personal data`,
  'центр организует для московских производителей программу по направлениям:':`The center organizes a program for Moscow manufacturers in the following areas:`,
  'выездные и реверсные бизнес-миссии (online и offline)':`Onsite and reverse business missions (online and offline)`,
  'онлайн':`Online`,
  'оффлайн':`Offline`,
  'нет данных': 'No data',
  'технологические туры':`Technological tours`,
  'видео':`Videos`,
  'предпродажные мероприятия (online и offline), включая matchmaking':`Pre-sales activity (online and offline), including MatchMaking`,
  'отправить заявку':`File an application`,
  'ваш вопрос':`Your question`,
  'целевой рынок':`Target market`,
  'форма проведения':`Event format`,
  'исполнение региональных проектов':`FULFILLMENT OF REGIONAL PROJECTS`,
  'аналитические исследования рынков и ликвидности конкретных товаров': 'Analytical research of markets and liquidity of particular commodities',
  'помощь в поиске бизнес-партнеров и подбор международных покупателей под запросы московских производителей': 'Assistance in the search for business partners and international buyers for products of Moscow manufacturers',
  'верификация контрагентов, гарантия их благонадежности': 'Verification of counterparties, guarantee of their reliability',
  'организация переговоров и помощь в их проведении': 'Organization of and assistance in negotiations',
  'организация выездных, реверсных бизнес-миссий и технологических туров на московские производства':'Organization of onsite and reverse business missions and technological tours to Moscow production facilities',
  'более 700 московских производителей':`OVER 700 MOSCOW MANUFACTURERS`,
  'индивидуальный подход к каждому запросу':`PERSONALIZED APPROACH TO EVERY APPLICATION`,
  'квалифицированные эксперты в области вэд':`SKILLED EXPERTS IN FOREIGN ECONOMIC ACTIVITY`,
  'интересное':`INTERESTING FACTS`,
  'истории успеха':`Story of success`,
  'история успеха':`Story of success`,
  'интервью':`Interviews`,
  'галерея':`Gallery`,
  'контактная информация для сми:':`Contact information for media:`,
  'доб':`extension`,
  'статьи':`Articles`,
  'спецпроекты':`Special projects`,
  'внешние мероприятия':`External events`,
  'читать подробнее':`Read more`,
  'последние новости':`Breaking News`,
  'обратная связь':`Feedback`,
  'ваше имя':`Your name`,
  'ваш e-mail':`Your email`,
  'тема':`Subject`,
  'сообщение':`Message`,
  'скачать файл':'Download',
  'скачать':'Download',
  'информация предоставлена за':'Information provided for',
  'год':'year',
  'экспортер':`Exporter`,
  'байер':`Buyer`,
  'все документы действительны.':`All documents are valid.`,
  'справка':`Information`,
  'ннэ москвы':`Moscow’s non-resource non-energy export`,
  'промышленный экспорт':`Industrial export`,
  'экспорт апк':`Agro-industrial complex export`,
  'экспорт промышленной продукции':`Exports of industrial products`,
  'экспорт продукции апк':`Agro-industrial exports`,
  'по отраслям':`by industry`,
  'топ {0} товаров':'Top {0} commodities',
  'топ {0} стран':'Top {0} countries',
  'несырьевой неэнергетический экспорт города москвы:':`Moscow’s non-resource non-energy exports amounted to:`,
  'место москвы среди регионов рф (доля в ннэ):':`Moscow’s place among Russian regions (share in non-resource non-energy exports):`,
  'доля ннэ в совокупном экспорте москвы:':`The share of non-resource non-energy products in Moscow’s exports is:`,
  '1 место':`First`,
  'место':`Place`,
  'назад':`Back`,
  'загрузка':`Loading`,
  'вперед':`Forward`,
  'оценка условий труда':`Assessment of working conditions`,
  'закон о коррупции':'Corruption Law',
  'реестр недобросовестных получателей мер поддержки':'Register of unscrupulous recipients of support measures',
  'отчет о ходе исполнения мероприятий планов противодействия коррупции за 2020 год.docx':'Progress report on the implementation of measures of anti-corruption plans for 2020 (.docx)',
  'отчет о ходе исполнения мероприятий планов противодействия коррупции за 1 полугодие 2021.pdf':'Report on the progress of the implementation of measures of anti-corruption plans for the 1st half of 2021 (.pdf)',
  'отчет о ходе исполнения мероприятий планов противодействия коррупции за 2 полугодие 2021.pdf':'Report on the progress of the implementation of measures of anti-corruption plans for the 2nd half of 2021 (.pdf)',
  'документы': 'Documents',
  'комментарии': 'Comments',
  'как получить поддержку?': 'How to receive support?',
  'cкачать аналитический обзор': 'Download Analytical report',
  'многоотраслевая': 'Miscellaneous',
  'продукция апк': 'Agro-industrial products',
  'промышленная/апк': 'Industrial/Agro-industrial products',
  'промышленная': 'Industrial',
  'бизнес-миссия': 'Business mission',
  'выставка': 'Exhibition',
  'обучение': 'Coaching',
  'событие': 'Event',
  'помощь в продвижении продукции':'Assistance in the promotion of products',
  'исследование потенциальных рынков':'Research of potential markets',
  'проверка готовности к экспорту':'Export preparedness test',
  'в течении следующего месяца':'Within next month',
  'в течении полугода':'Within six months',
  'не установлено':'Indefinite',
  'мсп':'SME',
  'остальное(все)':'Other (all)',
  'нефинансовые':'Non-financial',
  'финансовые':'Financial',
  'в избранное':'Add to favourites',
  'в избранном':'Added to favourites',
  'января':'January',
  'февраля':'February',
  'марта':'March',
  'апреля':'April',
  'мая':'May',
  'июня':'June',
  'июля':'July',
  'август':'August',
  'сентября':'September',
  'октября':'October',
  'ноября':'November',
  'декабря':'December',
  'нажимая кнопку «отправить»':'By clicking the "submit" button',
  'вы соглашаетесь с':'you agree to the',
  'политикой конфиденциальности':'privacy policy',
  /* Tests */
  'описание теста квалификации':
    `Для прохождения этапа Квалификация необходимо ответить на 30 вопросов. Информация, полученная из ответов, позволяет оценить деятельность компании с разных сторон и понять общий уровень экспортного потенциала компании.`,
  'описание теста валидации':
    `На этапе Валидация проводится глубокий анализ предстоящей экспортной деятельности компании с учетом конкретного продукта и целевого рынка. На этом этапе нужно ответить на 44 вопроса. Для выхода на этап Валидации необходимо успешно пройти этап Квалификации.`,
  'заголовок adept7':
    `Автоматизированный экспортный консультант, предназначенный для поддержки экспортно ориентированных компаний города Москвы.`,
  'краткое описание adept7':
    `Нажмите ниже, чтобы узнать подробнее об ADEPT7 или перейти к тесту.`,
  'выберите страну экспорта...':
    `Выберите страну, в которую планируется экспорт, код ТН ВЭД категории товара на уровне 6-ти знаков и укажите продукт в текстовом поле`,
  'почему это важно': 'Почему это важно?',
  'подзаголовок adept7':
    `Оценка экспортного потенциала компании производится в два этапа.`,
  'полное описание adept7 1':
    `Этап Квалификации - для его прохождения Вам необходимо ответить на 30 вопросов. Информация, полученная из ответов, позволяет оценить деятельность компании с разных сторон и понять общий уровень экспортного потенциала компании.`,
  'полное описание adept7 2':
    `На этапе Валидация проводится более глубокий анализ предстоящей деятельности компании с учетом конкретного продукта и целевого рынка. На этом этапе нужно ответить на 44 вопроса. Для выхода на этап Валидации необходимо успешно пройти этап Квалификации.`,
  'полное описание adept7 3':
    `Проверка готовности компании к экспорту проводится в разрезе 7 измерений, по каждому из которых формируются оценки и рекомендации: Люди и компетенции, Средства, Инфраструктура и адаптивность, Мотивация и цели, Среда, Продукт, Внедрение. Оценки по измерениям зависят от выбранных ответов в опроснике: каждый ответ на вопрос может вносить определенный вклад в оценку по одному или нескольким измерениям. Вопросы для опросников двух этапов разные. Отчет по каждому этапу сопровождается оценкой потенциала, отражающей вероятность успеха в планируемой экспортной деятельности. Для успешного прохождения она должна быть не менее 0,5. Оценки результатов теста по каждому из 7 измерений помогают определить, насколько высок потенциал компании при экспортной деятельности по каждому из направлений. Для визуализации результатов, в отчете строится лепестковая диаграмма, наглядно демонстрирующая, насколько далеко результаты теста компании находятся от граничных значений (либо попадают в «красную зону») по каждому измерению.  Граничные оценки на каждом этапе одинаковы для всех компаний и означают точку перехода от положительного знака влияния значения по данному измерению на итоговый результат оценки экспортного потенциала - к отрицательному.`,
  'полное описание adept7 4':
    `Пройдя опросник, вы получаете рекомендации относительно того, какие направления деятельности вашей компании следует развивать в первую очередь для создания условий ее успешного выхода на экспортные рынки.`,
  'почему это важно заголовок':
    `Важность численной оценки экспортной готовности.`,
  'почему это важно текст':
    `Степень экспортной готовности является одним из основных критериев при принятии решения о выходе компании на экспорт. Многочисленный международный опыт определения экспортного потенциала компаний говорит о том, что численная оценка – это лучший способ описания экспортной готовности. Численная характеристика беспристрастна. Она дает возможность объективно оценить отдельные аспекты деятельности компании, которые влияют на готовность к экспорту. Зная численную оценку экспортной готовности компании, можно спрогнозировать вероятность успеха потенциальной экспортной деятельности и ее последующую экономическую эффективность. При всей своей простоте использования и минимальности время-затрат, оценка потенциала собственной экспортной готовности может стать главным «компасом» на вашем пути к успеху на международных рынках.`,
  'удаление черновика':
    `Копия документа, подтверждающего полномочия главного бухгалтера или иного лица, ответственного за ведение бухгалтерского учета.`,
  'сохранение черновика':
    `Сохраненная сессия будет доступна только 7 дней с момента начала заполнения опросника. Сессия будет доступна до `,
  'этап квалификации не пройден':
    `Этап «Квалификация» не пройден. Следуйте рекомендациям в отчете. Повторное прохождение этапа «Квалификация» станет доступным через 6 месяцев, `,
  'квалификация': 'Qualification',
  'валидация': 'Validation',
  'сохранить и выйти': 'Save and exit',
  'подтвердить': 'Confirm',
  'далее': 'Next',
  'завершить': 'Complete',
  'вопрос': 'Question',
  'из': 'of', // 3 of 9
  'место проведения':'Location',
  'отчет о проведении соут ано моспром':'Report on SAUT ANO Mosprom',
  'недопустимый формат электронной почты':'Invalid email format',
  'введите номер телефона полностью':'Enter your phone number',
  'введите не менее {0} символов':'Enter at least {0} characters',
  'данное поле не может быть длиннее {0} символов':'Field cannot be longer than {0} characters',
  'заполните поле пароля':'Fill in the password field',
  'поле обязательное для заполнения':'Required field',
  'вы успешно зарегистрировались. перейти в личный кабинет?':'You have successfully registered. Go to your personal account?',
  'перейти в лк':'Go to account',
  'моя лента':'Newswire',
  'уведомления':'Notifications',
  'профиль':'Profile',
  'календарь':'Calendar',
  'заявки':'Applications',
  'перейти на сайт':'Go to the website',
  'выход':'Log out',
  'вы действительно хотите выйти из личного кабинета?':'Do you really want to log out of your account?',
  'выйти':'Log out',
  'отмена':'Cancel',
  'публикация новости...':
    `You can publish your news on the website of the Mosprom Center for Exports Support and Development.`,
  'предложить новость':'Offer news',
  'заполните заявку на публикацию новости и прикрепите необходимые файлы':'Fill out an application for news publication and attach the necessary files',
  'название новости':'News title',
  'ссылка на источник':'Link to news source',
  'текст новости':'News text',
  'профиль компании':'Company profile',
  'статус':'Status',
  'редактировать данные':'Edit data',
  'отменить':'Cancel',
  'сохранить':'Save',
  'реквизиты':'Requisites',
  'ответственный':'Designated employee',
  'основные документы':'Basic documents',
  'презентационные материалы':'Presentation materials',
  'основные данные':'Basic data',
  'добавить файл':'Add file',
  'Формат файла: pdf': 'File format: pdf',
  'Максимальный размер файла: 30mb': 'Max file size: 30mb',
  'удалить':'Delete',
  'данные компании':'Company profile',
  'обязательно проверьте правильность данных перед сохранением.':'Be sure to check the data is correct before saving.',
  'если ваша организация входит в группу компаний, укажите название управляющей компании.':'If your company belongs to a group, please indicate the name of your managment company.',
  'добавить холдинг':'Add Holding',
  'отправить данные':'Send data',
  'все заявки':'All aplications',
  'архив':'Archive',
  'поиск':'Search',
  'добавленные меры':'Added measures',
  'сообщить о барьере':'Report a barrier',
  'получите индивидуальные меры поддержки':'Receive individual support',
  'на данный момент нет добавленных мер поддержки. вы можете добавить их, перейдя на сайт, в раздел':'No support measures added. You may add measures by visiting the website section',
  'если у вас возникли трудности с выходом на новый рынок, наши специалисты помогут найти решение.':'If you have any difficulties entering a new market, our experts will help you find a solution.',
  'опишите вашу проблему':'Describe your problem',
  'заявка на индивидуальные меры поддержки':'Application for individual support measures',
  'пожалуйста, проверьте действительность документов. некоторые документы необходимо обновить.':'Please check the validity of the documents. Some documents need to be updated.',
  'контактные данные':'Contact details',
  'проверка документов':'Verification of documents',
  'задайте свой вопрос и мы ответим на него в ближайшее время':'Ask a question, and we will give an answer shortly',
  'основные вопросы':'FAQ',
  'биржа контактов':'Contacts',
  'от кого':'from',
  'снять отметку':'Unmark',
  'пометить флажком':'Mark',
  'документ отсутствует': 'Document missing',
  'на проверке': 'On check',
  'обновите документ': 'Update the document',
  'документ действителен': 'Document is valid',
  'категория':'Category',
  'все категории':'All categories',
  'мероприятие':'Event',
  'без заявки':'Without application',
  'заявка отклонена':'Rejected',
  'отклонено':'Rejected',
  'требуется отчет':'Report required',
  'заявка одобрена':'Approved',
  'заявка подана':'Approved',
  'заявка на рассмотрении':'Pending',
  'на рассмотрении':'Pending',
  'все статусы':'All',
  'помощь':'Assistance',
  'очистить фильтр':'Clear filter',
  'номер':'Number',
  'номер заявки':'Number',
  'дата подачи':'Date',
  'наименование':'Name',
  'статус заявки':'Application status',
  'информация о заявке':'Application Information',
  'не указан':'Not specified',
  'перейти в профиль':'Go to profile',
  'заявка на индивидуальные аналитические исследования':'Application for individual analytical studies',
  'индивидуальные исследования':'Individual research',
  'индивидуальные аналитические исследования':'Individual analytical studies',
  'получите индивидуальные исследования прямо сейчас':'Get customized research right now',
  'на данные момент индивидуальные аналитические исследования отсутствуют.':'There are currently no individual analytical studies.',
  'наименование компании':'Company name',
  'полное наименование компании':'Full company name',
  'полное наименование на английском':'Full company name in English',
  'статус компании':'Company status',
  'регион организации':'Region of organization',
  'дата регистрации':'Registration date',
  'сектор апк/пк':'Industrial/Agro-industrial sector',
  'виды деятельности/отрасль':'Activities / Industry',
  'описание деятельности':'Activity description',
  'коды оквэд':'OKVED codes',
  'коды тнвэд':'HS codes',
  'юридический адрес орг-ции':'Organization legal address',
  'фактический адрес орг-ции':'Organization actual address',
  'инн организации':'Organization TIN',
  'огрн организации':'Organization PSRN',
  'кпп организации':'Organization IEC',
  'веб-сайт':'Web site',
  'рабочий телефон':'Company phone',
  'фио руководителя':`Manager's Full Name`,
  'должность руководителя':'Head position',
  'внутрення ошибка проверки документов':'Internal error checking documents',
  'поиск экспортера':'Search for an exporter',
  'поиск байера':'Search for a buyer',
  'укажите название файла':'Enter file name',
  'добавить документ':'Add document',
  'изменить':'Change',
  'обновить':'Refresh',
  'загрузить':'Upload',
  'найдено предложений':'Found offers',
  'каталог':'Catalog',
  'данные обновлены':'Data updated',
  'данные отправлены':'Data sended',
  'данные отправлены!':'Data sended',
  'ошибка загрузки, повторите позже':'Load error, please try again later',
  'ошибка отправки данных':'Load error',
  'не найдено активной учетной записи с указанными данными':'No active account found with the specified data',
  'ваш запрос':'Your request',
  'связаться с компанией':'Contact the company',
  'запрос на связь с компанией':'Request to contact the company',
  'сфера деятельности':'Field of activity',
  'география поставки':'Delivery regions',
  'сайт компании':'The site of the company',
  'общая информация':'General information',
  'открыть каталог':'Open directory',
  'открыть портал поставщиков':'Open supplier portal',
  'восстановление пароля':'Password recovery',
  'введите email, который вы использовали при регистрации':'Enter the email you used when registering',
  'восстановить':'Restore',
  'вы робот?':'Are you a ROBOT?',
  'введите новый пароль':'Enter a new password',
  'новый пароль':'New password',
  'описание главного медиа раздела...':
    `The main export news of Russia and the world, Fascinating interviews with the heads of large capital companies, as well as advice from the leading exporters of the capital. Read all this and more in our section.`,
  'запрос на смену пароля отправлен, проверьте почту':'Password change request sent, please check your email',
  'пароль успешно изменен':'Password changed successfully',
  'Благодарим за регистрацию!':'Thank you for registering!',
  'Ссылка для активации аккаунта отправлена на указанный адрес электронной почты - ':'The activation link has been sent to the specified email address - ',
  'Пожалуйста, активируйте свой аккаунт, чтобы получить возможность зайти в личный кабинет.':'Please activate your account to gain access to your personal profile.',
  'Аккаунт успешно активирован!':'Account successfully activated!',
  'Спасибо за активацию вашего аккаунта! Теперь вы можете войти в свой личный кабинет и начать пользоваться сервисом.':'Thank you for activating your account! Now you can log into your personal account and start using the service',
  'Однако, пока ваш аккаунт не пройдет модерацию, доступ к некоторым функциям может быть ограничен.':'However, until your account passes moderation, access to some features may be restricted.'
};
